import { Widget } from "blue-widgets";

class ExpandableGroup extends Widget {
  constructor(el) {
    super(el);
    this.init();
  }

  init() {
    const children = this.el.querySelectorAll(
      "[data-widget='Expandable'], [data-widget='HeaderDropdown'], [data-widget='CustomSelect']"
    );
    children.forEach((el) => {
      el.addEventListener(
        "expandable-toggled",
        (e) => {
          e.stopPropagation();
          this.collpaseSiblings(e);
        },
        false
      );
    });
  }

  collpaseSiblings(e) {
    const closestParent = e.target.closest("[data-widget='ExpandableGroup']");
    const currentlyOpen = closestParent.querySelectorAll(".isOpen");
    currentlyOpen.forEach((el) => {
      if (el !== e.target) {
        const closeEvent = new CustomEvent("close-expandable");
        el.dispatchEvent(closeEvent);
      }
    });
  }

  beforeRemove() {
    const children = this.el.querySelectorAll("[data-widget='Expandable']");
    children.forEach((el) => {
      el.removeEventListener(
        "expandable-toggled",
        this.collpaseSiblings,
        false
      );
    });
  }
}

export default ExpandableGroup;
